import fields from '@/components/fields/'

const headerFields = context => {
  return [
    new fields.Input({
      label: 'Tytuł nagłówka',
      modelPath: [context, 'form', 'header_title'],
      type: 'textarea'
    }),
    new fields.Input({
      label: 'Opis nagłówka',
      modelPath: [context, 'form', 'header_description'],
      type: 'textarea'
    }),
    new fields.Image({
      label: 'Zdjęcie (desktop)',
      modelPath: [context, 'form', 'header_image']
    }),
    new fields.Image({
      label: 'Zdjęcie (tablet)',
      modelPath: [context, 'form', 'header_tablet_image']
    }),
    new fields.Image({
      label: 'Zdjęcie (mobile)',
      modelPath: [context, 'form', 'header_mobile_image']
    })
  ]
}

export default headerFields
